export default __webpack_public_path__ + "static/media/robotica.2fb14963.jpeg";